import React from "react";
import TYPES from "./constants";

import CheckboxField from "./checkboxField/checkboxField.component";
import RadioField from "./radioField/radioField.component";
import NumberField from "./numberField/numberField.component";
import SimpleTextField from "./simpleTextField/simpleTextField.component";
import SelectField from "./selectField/selectField.component";
import RankingField from "./rankingField/rankingField.component";
import SimpleTextAreaField from "./simpleTextAreaField/simpleTextAreaField.component";
import RichTextField from "./richTextField/richTextField.component";
import TitleTextField from "./titleTextField/titleTextField.component";
import FileField from "./fileField/fileField.component";
import DateField from "./dateField/dateField.component";
import LocationField from "./locationField/locationField.component";
import InputOtherField from "./inputOtherField/inputOtherField.component";
import ConsentCheckboxField from "./consentCheckboxField/consentCheckboxField.component";

const Field = ({ type, ...props }) => {
  switch (type) {
    case TYPES.CHECKBOX:
      return <CheckboxField {...props} />;
    case TYPES.RADIO:
      return <RadioField {...props} />;
    case TYPES.NUMBER:
      return <NumberField {...props} />;
    case TYPES.SIMPLE_TEXT:
      return <SimpleTextField {...props} />;
    case TYPES.SELECT:
      return <SelectField {...props} />;
    case TYPES.RANKING:
      return <RankingField {...props} />;
    case TYPES.SIMPLE_TEXTAREA:
      return <SimpleTextAreaField {...props} />;
    case TYPES.TEXTAREA:
      return <RichTextField {...props} />;
    case TYPES.TITLE:
      return <TitleTextField {...props} />;
    case TYPES.FILE:
      return <FileField {...props} />;
    case TYPES.DATE:
      return <DateField {...props} />;
    case TYPES.LOCATION:
      return <LocationField {...props} />;
    case TYPES.INPUT_OTHER:
      return <InputOtherField {...props} />;
    case TYPES.CONSENT_CHECKBOX:
      return <ConsentCheckboxField {...props} />;
    default:
      return <input type="text" {...props} />;
  }
};

export { TYPES };
export default Field;
